import MegaMenu from './components/mega-menu.js';

// eslint-disable-next-line no-unused-vars
const theMegaMenu = new MegaMenu(document.querySelector('.js-MegaMenu'));
